export default "__VITE_ASSET__3fc54538__"